export const partitionByIndex = <T extends any[]>(arr: T, index: number) => [
  arr.slice(0, index),
  arr.slice(index),
]
